import React, { useRef } from 'react';
import {
  Box,
  Text,
  Switch,
  Spacer,
  SideSheet,
} from '@flexisaf/flexibull2';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import {
  fetchMoreNotifications,
  readNotification,
} from 'redux/notifications/actions';
import {
  notifications,
  fetchingNotifications,
  fetchedPageNumber,
} from 'redux/notifications/selectors';
import {
  QueryTaskNotification,
  ApplicaitonSummaryNotification,
  BackgroundTaskNotification,
} from 'components/notification';
import { calculateOffset } from 'utils/helpers';

const NotificationItem = ({ notification, toggleRead }) => {
  switch (notification.type) {
    case 'APPLICATION_SUBMISSION_SUMMARY':
      return (
        <ApplicaitonSummaryNotification
          notification={notification}
          toggleRead={toggleRead}
        />
      );
    case 'BACKGROUND_TASK':
      return (
        <BackgroundTaskNotification
          notification={notification}
          toggleRead={toggleRead}
        />
      );
    case 'RE_QUERY_PAYMENT':
      return (
        <QueryTaskNotification
          notification={notification}
          toggleRead={toggleRead}
        />
      );
    default:
      return null;
  }
};

export const Notifications = (props) => {
  const listInnerRef = useRef(null);
  const dispatch = useDispatch();
  const currentPage = useSelector(fetchedPageNumber);
  const notificationsFetched = useSelector(notifications);
  const loading = useSelector(fetchingNotifications);

  const triggerReadNotification = (notice) => {
    dispatch(readNotification(notice));
  };

  const fetchMore = () => {
    const num = currentPage + 1;
    const offSet = calculateOffset(num, 15);
    if (notificationsFetched?.resultTotal !== currentPage) {
      dispatch(
        fetchMoreNotifications({
          currentPage: offSet,
        })
      );
    }
  };

  const onScroll = () => {
    if (listInnerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
      if (Math.round(scrollTop + clientHeight) + 1 >= scrollHeight) {
        fetchMore();
      }
    }
  };

  return (
    <>
      <SideSheet width="600px" open={props.open} onClose={() => props.close()}>
        <Box>
          <Box
            display="flex"
            style={{
              justifyContent: 'space-between',
              alignContent: 'center',
              height: '8vh',
            }}
            pad="30px 40px"
            background="#f2f2f2"
          >
            <Box vAlign>
              <Text size="18px" bold>
                Notifications
              </Text>
              {/* unable to get total notifications yet */}
              {/* <Tag
                  pad="0 10px"
                  spaceLeft
                  height={20}
                  color={Theme.PrimaryRed}
                >
                  133
                </Tag> */}
            </Box>
          </Box>
          <Box
            display="flex"
            pad="10px 20px 10px 40px"
            vAlign
            style={{
              height: '5vh',
            }}
          >
            <Text bold>
              <span style={{ cursor: 'pointer' }}>Mark all as read</span>
            </Text>
            <Box margin="0 0 0 auto" vAlign>
              <Text color="">Show only unread notifications</Text>
              <Switch disabled size={15} elevate="high" />
            </Box>
          </Box>
          <Box
            onScroll={onScroll}
            ref={listInnerRef}
            pad="0"
            style={{
              height: '86vh',
              overflowY: 'auto',
            }}
          >
            {notificationsFetched?.data?.map((notice) => (
              <NotificationItem
                key={notice.id}
                notification={notice}
                toggleRead={() => triggerReadNotification(notice)}
              />
            ))}
            {loading && (
              <Box width="100%" pad="15px 40px" vAlign>
                <SkeletonTheme color="#d0d5d933" highlightColor="#c2cad133">
                  <Box width="fit-content" margin="0 0 0 auto">
                    <Skeleton count={1} height={20} width={400} />
                    <Spacer space="15px" />
                    <Skeleton count={1} height={20} width={300} />
                  </Box>
                </SkeletonTheme>
              </Box>
            )}
          </Box>
        </Box>
      </SideSheet>
    </>
  );
};

Notifications.propTypes = {
  open: PropTypes.bool,
  close: PropTypes.func,
};

NotificationItem.propTypes = {
  notification: PropTypes.object,
  toggleRead: PropTypes.func,
};
